<div class="modal-header">

    <div *ngIf="message && message.body" [innerHTML]="getSanitizedHtml(message.body)"></div>
</div>
